import { clearUploadSession } from "../data-source/upload-payloads";

export function clearSessionUploads() {
  clearUploadSession();
}
